export const transformTitle = title => {
  const words = title.split(' ')
  const index = words.length % 2 === 0 ? words.length / 2 : Math.ceil(words.length / 2)

  return words.reduce((sentance, word, i) => {
    let result = sentance
    result += i === index ? `<br />${word} ` : `${word} `
    return result
  }, '')
}

export const removeDuplicates = ({ cities }) => {
  const key = 'cityName'
  const unique = [...new Map(cities.map(item => [item[key].toLowerCase(), item])).values()]
  return unique
}
